import { gql } from '@apollo/client';

export const DELETE_CURRENCY_GROUP = gql`
  mutation deleteCurrencyGroup($id: ID!) {
    currencyGroup: deleteCurrencyGroup(id: $id) {
      id
    }
  }
`;
